// logo
export const logo = {
  url: 'https://img.alicdn.com/tfs/TB14rs5xmf2gK0jSZFPXXXsopXa-412-102.png',
  murl: 'https://img.alicdn.com/tfs/TB16e9GLzTpK1RjSZKPXXa3UpXa-600-143.png',
  title: '浙江扁鹊健康科技有限公司',
};
export const brushLogo = {
  url: 'https://img.alicdn.com/tfs/TB1lKpTiQP2gK0jSZPxXXacQpXa-204-126.png',
  title: '阿里巴巴集团',
  murl: 'https://img.alicdn.com/tfs/TB1hQRUiKH2gK0jSZFEXXcqMpXa-418-102.png',
  mtitle: '浙江扁鹊健康科技有限公司',
};

// navigation
export const navList = [
  {
    name: '首页',
    path: '/',
  },
  {
    name: '解决方案',
    subTitle: 'solutions',
    path: '/solution',
  },
  {
    name: '产品与服务',
    subTitle: 'products and services',
    path: '/product',
  },
  {
    name: '关于扁鹊',
    subTitle: 'about us',
    path: '/about',
  },
  {
    name: '联系我们',
    subTitle: 'contact us',
    path: '/contact',
  },
];

// brush
export const brushList = [
  {
    name: '产品中心',
    subTitle: 'products',
    path: '/',
  },
  {
    name: '关于我们',
    subTitle: 'about us',
    path: '/about',
  },
];
